import { ApiService } from "pwapi";

import { DEAUTHENTICATE } from "../actions/constants";
import { GET_SITE_SPECIFIC_CODES_SUCCESS } from "../actions/siteSpecificCodesActions";
import { SagaAction } from "../utils/asyncActions";

export type SiteSpecificCodes = Awaited<
  ReturnType<typeof ApiService.siteSpecificIcd10Code>
> | null;

const initialState: SiteSpecificCodes = null;
const siteSpecificCodesReducer = (
  state: SiteSpecificCodes = initialState,
  action: SagaAction
) => {
  switch (action.type) {
    case GET_SITE_SPECIFIC_CODES_SUCCESS:
      return action.payload?.response as SiteSpecificCodes;
    case DEAUTHENTICATE:
      return null;
    default:
      return state;
  }
};

export default siteSpecificCodesReducer;
